/**
 * Hour meters and odometers (migration 0034).
 *
 * A machine's hour_meter_unit says what its meter counts. Every reading
 * column keeps its name and holds the machine's own unit — a truck's
 * "hour meter" columns hold kilometres — so screens take their labels and
 * suffixes from here rather than hard-coding "h".
 */
export type MeterUnit = 'hours' | 'km';

export const METER_UNITS: { value: MeterUnit; label: string }[] = [
  { value: 'hours', label: 'Hours — hour meter' },
  { value: 'km', label: 'Kilometres — odometer' },
];

export function unitOf(m: { hour_meter_unit?: string | null } | null | undefined): MeterUnit {
  return m?.hour_meter_unit === 'km' ? 'km' : 'hours';
}

/** "h" or "km", for number suffixes. */
export function meterSuffix(unit: MeterUnit): string {
  return unit === 'km' ? 'km' : 'h';
}

/** "hour meter" or "odometer", for labels. */
export function meterName(unit: MeterUnit): string {
  return unit === 'km' ? 'odometer' : 'hour meter';
}

/** The most one shift can plausibly add to the meter. */
export function maxPerShift(unit: MeterUnit): number {
  return unit === 'km' ? 2000 : 24;
}
